export default {
    appName: "Kazigraphix",
    domain: process.env.NODE_ENV == 'production' ? 'https://www.kazigraphix.com' : 'http://127.0.0.1:8000',
    localUserKey: "kazigraphix_utk"
}
